module.exports = __webpack_public_path__ + "static/roca-c15f3d761cbe336a29a50878eeb967e0.woff2";